import { useTranslation } from 'react-i18next';

import { OrderFormValue } from 'support/helpers/orderForms/orderForms';
import { OrderFormProductDTO } from 'support/types';

import { OrderedProductDetail } from './OrderedProductDetail';

type OrderedProductsProps = {
  orderedProducts: Record<string, OrderFormValue>;
  productsData: Record<string, OrderFormProductDTO>;
  currency: string | undefined;
};

export function OrderedProducts({ orderedProducts, productsData, currency }: OrderedProductsProps) {
  const { t } = useTranslation();
  return (
    <div className="pt-8 pb-5 *:not-first:mt-4 first:pt-0 last:pb-0">
      <span className="text-xs text-gray-500">{t('orderForms:checkout.summary')}</span>
      <dl className="grid grid-cols-[min-content_1fr_min-content] gap-4">
        {Object.entries(orderedProducts).map(([productId, ordered]) => (
          <OrderedProductDetail
            key={productId}
            quantity={ordered.quantity}
            currency={currency}
            productData={productsData[productId]}
          />
        ))}
      </dl>
    </div>
  );
}
